import React from "react";
import axios from "axios";
import Spinner from "../../components/Spinner";
import { Modal } from "../../components/Modal";

const API = localStorage.getItem("assethost");

export default class FlagAppend extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      msg: "",
      toastColor: "",
      assetId: "",
      flag: null,

      policeReportFile: null,
      errors: {},
      valid: true,
    };
    this.handleFileChange = this.handleFileChange.bind(this);
    this.handleAppend = this.handleAppend.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.validate = this.validate.bind(this);
  }

  componentDidMount() {
    const urlParams = new URLSearchParams(window.location.search);
    let assetId = urlParams.get("assetId");
    if (!assetId) {
      assetId = this.props.assetId;
    }
    let flag = this.props.flag;
    const token = sessionStorage.getItem("token");
    if (!token) {
      this.setState({
        msg: "No User Token",
        toastColor: "danger",
      });
      sessionStorage.clear();
      window.location.href = `/?redirectUrl=${
        window.location.pathname + window.location.search
      }`;
      return;
    }

    if (assetId) {
      axios
        .get(API + "/asset/getflaggedappend/" + flag.flagId, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((response) => {
          const data = response.data || {};
          flag.flagDate = data.flagDate;
          flag.country = data.country;
          flag.townCity = data.townCity;
          flag.houseBuildingNoStreet = data.houseBuildingNoStreet;
          flag.surbub = data.surbub;
          this.setState({
            assetId,
            flag,
          });
        })
        .catch((error) => {
          // Don't show error for dropdown loading failure, just continue
          console.log("Failed to load dropdowns:", error);
        });
    } else {
      this.setState({
        msg: "No asset ID provided",
        toastColor: "danger",
      });
    }
  }

  handleFileChange(e) {
    const { name } = e.target;
    const file = e.target.files ? e.target.files[0] : null;
    this.setState({ [name]: file }, this.validate);
  }

  validate() {
    const s = this.state;
    let errors = {};
    let valid = true;

    if (!s.policeReportFile) {
      errors.policeReportFile = "Police report file is required";
      valid = false;
    }

    this.setState({ errors, valid });
    return valid;
  }

  handleAppend(e) {
    e.preventDefault();
    if (!this.validate()) {
      this.setState({
        msg: "Fix the errors above and try again.",
        toastColor: "danger",
      });
      return;
    }

    const token = sessionStorage.getItem("token");
    if (!token) {
      this.setState({
        msg: "No User Token",
        toastColor: "danger",
      });
      sessionStorage.clear();
      window.location.href = `/?redirectUrl=${
        window.location.pathname + window.location.search
      }`;
      return;
    }

    this.setState({ loading: true, msg: "", toastColor: "" });

    let request = new FormData();
    request.append("flagId", this.state.flag?.flagId);
    if (this.state.policeReportFile) {
      request.append("policeReportFile", this.state.policeReportFile);
    }

    axios
      .post(API + "/asset/assetflagappend", request, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        if (response.data.success) {
          this.setState({
            msg:
              response.data.message ||
              "Flag details appended successfully! Law enforcement has been notified.",
            toastColor: "success",
            loading: false,
          });
          setTimeout(() => {
            this.props.closeAction();
            if (this.props.onSuccess) {
              this.props.onSuccess();
            }
          }, 2000);
        } else {
          this.setState({
            msg: response.data.message || "Append failed",
            toastColor: "danger",
            loading: false,
          });
        }
      })
      .catch((error) => {
        if (Number(error.status) === 403) {
          sessionStorage.clear();
          window.location.href = `/?redirectUrl=${
            window.location.pathname + window.location.search
          }`;
        }
        this.setState({
          msg:
            error?.response?.data?.message ||
            "Append failed. Please try again.",
          toastColor: "danger",
          loading: false,
        });
      });
  }

  handleClose() {
    this.props.closeAction();
  }

  render() {
    const s = this.state;
    let divMsg = null;
    if (s.msg) {
      divMsg = (
        <div
          className={
            s.toastColor === "success"
              ? "alert alert-success mx-7"
              : "alert alert-danger mx-7"
          }
        >
          {s.msg}
        </div>
      );
    }

    if (s.loading) {
      return (
        <Modal title="Append Flag Details" footerContent={<></>}>
          <div className="w-100 h-10 overflow-hidden d-flex justify-content-center align-items-center">
            <Spinner className="" />
          </div>
        </Modal>
      );
    }

    return (
      <Modal
        title="Append Flag Details"
        closeAction={this.handleClose}
        footerContent={
          <>
            {s.valid && s.policeReportFile && (
              <button
                type="button"
                className="btn btn-primary disabled:cursor-not-allowed"
                disabled={!s.valid}
                onClick={this.handleAppend}
              >
                Append
              </button>
            )}
            <button
              type="button"
              className="btn btn-primary"
              onClick={this.handleClose}
            >
              Close
            </button>
          </>
        }
      >
        <div className="h-100 w-100 d-flex flex-column">
          {divMsg}
          <div className="row">
            <div className="col">
              <b>Type: </b>
              <span>{s.flag?.subcategoryName}</span>
            </div>
            <div className="col">
              <b>Unique Identifier: </b>
              <span>{s.flag?.uniqueIdentifier}</span>
            </div>
          </div>
          <div className="row">
            <div className="col">
              <b>Flag Type: </b>
              <span>{s.flag?.secondaryStatus}</span>
            </div>
            <div className="col">
              <b>Date: </b>
              <span>{s.flag?.flagDate}</span>
            </div>
          </div>
          <div className="row">
            <div className="col">
              <b>House / Building No: </b>
              {s.flag?.houseBuildingNoStreet}
            </div>
          </div>
          <div className="row">
            <div className="col">
              <b>Town / City: </b>
              {s.flag?.townCity}
            </div>
            <div className="col">
              <b>Country: </b>
              {s.flag?.country}
            </div>
          </div>
          <div className="row">
            <div className="col">
              <b>Have you made an official police report?: </b>
              {s.flag?.officialReport}
            </div>
          </div>
          <div className="row">
            <div className="col">
              <div className="input-group">
                <label className="input-group-text">Police Report File</label>
                <input
                  name="policeReportFile"
                  className={`form-control ${
                    s.errors.policeReportFile ? " !border-red-500" : ""
                  }`}
                  type="file"
                  onChange={this.handleFileChange}
                  accept=".pdf,image/*"
                  required
                />
                {s.errors.policeReportFile && (
                  <span className="input-group-error">
                    {s.errors.policeReportFile}
                  </span>
                )}
              </div>
            </div>
            <div className="col"></div>
          </div>
        </div>
      </Modal>
    );
  }
}
